module.exports = __webpack_public_path__ + "static/saint-julien-e549d64871cb68da1c4d977effa48d03.png";